<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name:'MoonTabsBody',
    };
</script>

<style lang="scss" scoped>

</style>